"use strict";

Shopify.theme.jsMap = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsMap = $.extend(this, Shopify.theme.getSectionData($section));
    var mapData = {
      address: this.map_address,
      apikey: this.api_key,
      sectionid: this.id,
      showpin: this.show_pin,
      zoom: this.zoom_level,
      map_style: this.map_style
    }; // Enable caching to avoid duplicate google maps files

    $.ajaxSetup({
      cache: true
    });

    $('.showroom-close').click(function(e) {
      e.preventDefault();
      $('.showroom-info').removeClass('showroom-info-open');
    });

    if (mapData.apikey) {
      // Load maps script and find location coordinates
      $.getScript('https://maps.googleapis.com/maps/api/js?key=' + mapData.apikey).then(function () {
        Shopify.theme.jsMap.findLocation(mapData);
        $.ajaxSetup({
          cache: false
        });
      });
    }
  },
  findLocation: function findLocation(mapData) {
    var geoLat;
    var geoLng;
    var geocoder = new google.maps.Geocoder(); // Find and set coordinates

    geocoder.geocode({
      address: mapData.address
    }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        geoLat = results[0].geometry.location.lat();
        geoLng = results[0].geometry.location.lng(); // Create map

        Shopify.theme.jsMap.initMap(geoLat, geoLng, mapData);
      } else {
        console.log('Error:' + status);
      }
    });
  },
  initMap: function initMap(lat, lng, mapData) {
    if ($(window).width() <= 798) {
      var location = {
        lat: 42.34238107751577, 
        lng: -71.06464079367176
        };
    } else {    
      var location = {
      lat: lat,
      lng: lng
      };
    };




    var styleJson = JSON.parse(mapData.map_style); // Set map options

    var mapOptions = {
      zoom: mapData.zoom,
      center: location,
      styles: styleJson,
      disableDefaultUI: true
    }; // Create map

    var map = new google.maps.Map(document.getElementById(mapData.sectionid), mapOptions); // Show pin

    if (mapData.showpin == true) {
      // var marker = new google.maps.Marker({
      //   position: location,
      //   map: map
      // });

  const showrooms = [{
          position: new google.maps.LatLng(42.34262352597618, -71.06528900097167),
          id: "casa_outdoor",
          name: "Casa Design Outdoor",
          address: "460 Harrison Ave<br>Boston, MA 02118<br><br>+1 617.955.9377<p class='email_us'><a href='/pages/contact-us/'>EMAIL US</a></p>",
        },{
          position: new google.maps.LatLng(42.34240618796203, -71.06452159184278),
          id: "casa_contract",
          name: "Bang & Olufsen + Casa Design",
          address: "460 Harrison Ave<br>Boston, MA 02118<br><br>+1 617.654.2974<p class='email_us'><a href='/pages/contact-us/'>EMAIL US</a></p>",
        },
        {
          position: new google.maps.LatLng(42.34269596221618, -71.06486263114019),
          id: "giorgetti",
          name: "Giorgetti",
          address: "450 Harrison Ave<br>Boston, MA 02118<br><br>+1 888.246.6451<p class='email_us'><a href='/pages/contact-us/'>EMAIL US</a></p>",
        },
        {
          position: new google.maps.LatLng(42.34241155898139, -71.06460844206974),
          id: "outlet",
         name: "OUTLET by Casa Design",
          address: "450 Harrison Ave<br>Boston, MA 02118<br><br>+1 617.654.2974<p class='email_us'><a href='/pages/contact-us/'>EMAIL US</a></p>",
        },
        {
          position: new google.maps.LatLng(42.34232850499798, -71.06440193126006),
          id: "casa_living",
          name: "Casa Design Living",
          address: "460 Harrison Ave<br>Boston, MA 02118<br><br>+1 617.654.2974<p class='email_us'><a href='/pages/contact-us/'>EMAIL US</a></p>",
        },
        {
          position: new google.maps.LatLng(42.342710634368466, -71.06497671815671),
          id: "molteni",
          name: "Molteni&C Flagship Store",
          address: "450 Harrison Ave<br>Boston, MA 02118<br><br>+1 617.858.0805<p class='email_us'><a href='/pages/contact-us/'>EMAIL US</a></p>",
        },
        {
          position: new google.maps.LatLng(42.3423343331745, -71.0642666069173),
          id: "clei",
          name: "Clei Boston",
          address: "460 Harrison Ave, Lobby B<br>Boston, MA 02150<br><br>+1 617.654.2974<p class='email_us'><a href='/pages/contact-us/'>EMAIL US</a></p>",
        }
      ];

      var icon_all = {
        path: 'M53.345,9.155c-12.207-12.207-31.982-12.207-44.189,0c-12.207,12.201-12.207,31.995,0,44.189    c0,0,22.083,21.655,22.083,46.655c0-25,22.106-46.655,22.106-46.655C65.552,41.15,65.552,21.356,53.345,9.155z M31.238,43.769    c-6.897,0-12.488-5.591-12.488-12.5s5.591-12.5,12.488-12.5c6.921,0,12.512,5.591,12.512,12.5S38.159,43.769,31.238,43.769z',
        fillColor: '#57525',
        scale: 0.5,
        fillOpacity: 0.7,
        strokeColor: '',
        strokeWeight: 0
      };
      var icon_active = {
        path: 'M53.345,9.155c-12.207-12.207-31.982-12.207-44.189,0c-12.207,12.201-12.207,31.995,0,44.189    c0,0,22.083,21.655,22.083,46.655c0-25,22.106-46.655,22.106-46.655C65.552,41.15,65.552,21.356,53.345,9.155z M31.238,43.769    c-6.897,0-12.488-5.591-12.488-12.5s5.591-12.5,12.488-12.5c6.921,0,12.512,5.591,12.512,12.5S38.159,43.769,31.238,43.769z',
        fillColor: '#57525',
        scale: 0.5,
        fillOpacity: 1,
        strokeColor: '',
        strokeWeight: 0
      };
      var markers =[];
      showrooms.forEach((showroom) => {

        var marker = new google.maps.Marker({
          position: showroom.position,
          title: showroom.name,
          content: showroom.address,
          map: map,
          icon: icon_all,
        });
        google.maps.event.addListener(marker, 'click', function (e) { 
         
          //console.log(this.title); 
          $('.showroom-info').addClass('showroom-info-open');
          $('.showroom-info').find('h3').text(this.title);
          $('.showroom-info').find('p').text('');
          $('.showroom-info').find('p').append(this.content);

          for (var j = 0; j < showrooms.length; j++) {
            markers[j].setIcon(icon_all);
          }

          this.setIcon(icon_active);

        });
        markers.push(marker);
      });



    }
  },
  unload: function unload($section) {}
};